import { ApiSuccessSchema } from "../../common/response.schema";
import {
  AnalyticsStructuredQueryBodySchema,
  AnalyticsStructuredQueryResultSchema
} from "../../public/v1/schemas/analytics.schemas";
import type { InferSchemas } from "../../schema-inference";

/**
 * Analytics v2 — internal (session-authed) API contracts.
 *
 * The same structured-query engine the public v1 API exposes (NEX-2478), but
 * reached with session/JWT auth so the in-app Analytics view can call it. The
 * org comes from the authenticated session (`@CurrentOrganizationId`), never an
 * api key. Schemas are reused verbatim from the public v1 layer — one contract,
 * two auth front doors.
 */
export const ZAnalytics = {
  /**
   * POST /api/analytics/query/structured
   * Run a structured (non-SQL) query over the curated, org-scoped views.
   */
  QueryStructured: {
    method: "POST" as const,
    path: "/api/analytics/query/structured",
    Body: AnalyticsStructuredQueryBodySchema,
    Response: ApiSuccessSchema(AnalyticsStructuredQueryResultSchema)
  }
} as const;

export type TApiAnalytics = InferSchemas<typeof ZAnalytics>;
